// extracted by mini-css-extract-plugin
export default {"hand-entry":"AddExistingMedicineForm_hand-entry__oLimX","button-wrap":"AddExistingMedicineForm_button-wrap__DEQcn"};